import React from "react";

import { ApolloProvider } from "@apollo/client";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import smoothscroll from "smoothscroll-polyfill";

import "styles/index.scss";
import "styles/preflight-overrides.css";
import App from "layout/App";
import "styles/main.css";
import "styles/bootstrap-compatibility.css";

import client from "./apollo";
import store from "./redux";

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  ChartDataLabels,
);

smoothscroll.polyfill();

const root = createRoot(document.getElementById("react-root"));

// Determine basename directly from Vite's BASE_URL so React-Router and the built assets stay in sync.
// Vite injects `import.meta.env.BASE_URL` which equals `/` during `vite dev` and the `base` option (e.g. `/app/`) in a production build.
const routerBasename =
  import.meta.env.BASE_URL && import.meta.env.BASE_URL !== "/"
    ? import.meta.env.BASE_URL.replace(/\/$/, "") // strip trailing slash
    : ""; // "" keeps local dev working

root.render(
  <ApolloProvider client={client}>
    <Provider store={store}>
      <BrowserRouter basename={routerBasename}>
        <App />
      </BrowserRouter>
    </Provider>
  </ApolloProvider>,
);
